export default __webpack_public_path__ + "static/media/email.3ffd9a4b.svg";